var paragraph_default = {
  "fontElementMap": "sVfjb",
  "elementSpacing": "tL1tz",
  "text": "LThh9 tL1tz",
  "child": "AAYkC"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
